/// <reference path="../typings/index.d.ts" />
namespace App.Modulos {
    export class Cadastro {
        public static inicializar() {
            var cadastro = new App.Cadastro();
            cadastro.inicializarEventos();
        }
    }
}

namespace App {
    export class Cadastro {

        public inicializarEventos() {
            let objgrecaptcha = new Grecaptcha();
            objgrecaptcha.inicializar();
        }
    }
}
